// src/components/IframeAutosizer.jsx
import { useEffect } from "react";

export default function IframeAutosizer({
  parentOrigin = window.location.origin, // 親が同一オリジンならこれでOK
  minHeight = 800,                        // 最低高さ（必要なら調整）
  debounceMs = 60,                        // 送信間引き
} = {}) {
  useEffect(() => {
    let raf = 0;
    let last = 0;

    const postHeight = () => {
      const h = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight,
        minHeight
      );
      window.parent.postMessage({ type: "IFRAME_HEIGHT", height: h }, parentOrigin);
    };

    const debouncedPost = () => {
      const now = performance.now();
      if (now - last > debounceMs) {
        last = now;
        postHeight();
      } else {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(postHeight);
      }
    };

    // DOMサイズ変化を監視（ルーティング／折りたたみ／画像読込等に追随）
    const ro = new ResizeObserver(debouncedPost);
    ro.observe(document.body);

    // 初期化や画像・フォント反映後にも再送
    window.addEventListener("load", postHeight);

    // 親から「高さ教えて」に応答
    const onMessage = (e) => {
      if (e.data && e.data.type === "REQUEST_IFRAME_HEIGHT") postHeight();
    };
    window.addEventListener("message", onMessage);

    // 最初に一回送る
    postHeight();

    return () => {
      ro.disconnect();
      window.removeEventListener("load", postHeight);
      window.removeEventListener("message", onMessage);
      cancelAnimationFrame(raf);
    };
  }, [parentOrigin, minHeight, debounceMs]);

  return null; // UIは持たない
}
